import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/Team.css';
import '../styles/ProjectGroups.css';
import { apiFetch } from '../utils/api';


export default function ProjectGroups() {
  const { groupName } = useParams();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [allMembers, setAllMembers] = useState([]);
  // No animation for members section; render immediately

  useEffect(() => {
    if (!groupName) return;
    setLoading(true);
    // Fetch all members first
    apiFetch('/api/members')
      .then(data => {
        const loadedMembers = Array.isArray(data.members) ? data.members : [];
        setAllMembers(loadedMembers);
        console.log('Loaded members for project group:', loadedMembers);
        // Now fetch project groups
        apiFetch('/api/project-groups')
          .then(data2 => {
            if (Array.isArray(data2)) {
              const found = data2.find(g => g.name === groupName);
              if (found) {
                console.log('Loaded project group:', found);
                setGroup(found);
              }
              else setError('Project group not found.');
            } else {
              setError('Failed to load project groups.');
            }
            setLoading(false);
          })
          .catch(() => {
            setError('Failed to load project groups.');
            setLoading(false);
          });
      })
      .catch(() => {
        setAllMembers([]);
        setError('Failed to load members.');
        setLoading(false);
      });
  }, [groupName]);

  if (!groupName) {
    return (
      <div className="team-container">
        <h2>No project group specified.</h2>
        <Link to="/team">Back to Team</Link>
      </div>
    );
  }

  if (loading) return <div className="team-container">Loading...</div>;
  if (error) return <div className="team-container team-error">{error}</div>;
  if (!group) return <div className="team-container">Project group not found.</div>;

  // Debug: log members array and allMembers
  console.log('group.members:', group.members);
  console.log('allMembers:', allMembers);

  return (
    <div className="team-container">
      {/* Debug style removed for production look */}
      {/* Hero section, styled exactly like Team page */}
      <section className="team-hero" style={{paddingBottom: 0}}>
        <div className="team-hero-content">
          <h1>{group.name}</h1>
          {group.category && <div className="team-projectgroup-category">{group.category}</div>}
          <p className="team-projectgroup-description">{group.description}</p>
          {group.image && (
            <div className="team-about-image">
              <img src={group.image} alt={group.name} style={{maxWidth:320, borderRadius:12, marginBottom:0}} />
            </div>
          )}
        </div>
      </section>

      {/* Content sections */}
      {Array.isArray(group.sections) && group.sections.length > 0 && (
        <section className="team-projectgroup-content" style={{marginTop: 40, marginBottom: 40}}>
          <div className="team-projectgroup-sections" style={{maxWidth: '820px', margin: '0 auto'}}>
            {group.sections.map((section, idx) => (
              <div
                key={idx}
                className={
                  section.type === 'image'
                    ? 'projectgroup-section-content-row image-row'
                    : 'projectgroup-section-content-row'
                }
              >
                {section.type === 'paragraph' ? (
                  <p className="projectgroup-section-paragraph">{section.content}</p>
                ) : section.type === 'image' && section.content ? (
                  <img
                    className="projectgroup-section-image"
                    src={section.content}
                    alt={group.name + ' image'}
                  />
                ) : null}
              </div>
            ))}
          </div>
        </section>
      )}

      {/* See Projects link */}
      <div style={{textAlign: 'center', margin: '32px 0'}}>
        <Link
          to={`/projects?category=${encodeURIComponent(group.category)}`}
          className="see-projects-link"
          style={{
            display: 'inline-block',
            padding: '12px 28px',
            background: '#0055a5',
            color: '#fff',
            borderRadius: '6px',
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '1.1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
          }}
        >
          See Projects from this Group and Category
        </Link>
      </div>

      {/* Members section, styled like Team page, moved to very bottom */}
      <div style={{marginTop:32}}>
        <section className="team-members-section animate" style={{marginTop:48, marginBottom: 32}}>
          <div className="team-members-container">
            <h2>Project Members</h2>
            {Array.isArray(group.members) && group.members.length > 0 ? (
              <div className="projectgroup-members-grid">
                {group.members.map(member => (
                  <div className="projectgroup-member-card" key={member._id || member.name}>
                    <img
                      className="projectgroup-member-image"
                      src={member.image || '/default-profile.svg'}
                      alt={member.name}
                    />
                    <div>
                      <div className="projectgroup-member-name">{member.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div>No members assigned.</div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}
